module.exports = __webpack_public_path__ + "./fonts/NachlieliCLM-Bold.ttf";